import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { YhBox } from "@/components/YhBox";
import { Button } from "antd";
import { exportPDF } from "@/utils/exportPDF";
import "../invoice/invoice.less"
import { customerService } from "@/views/base/customer/customerService";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useDrodDetailModel } from "../drodDetailModel";
import { enquiryService } from "@/views/document/customs/dtpService";
import { IDtpDetail, IDtpMaterialDetail } from "@/views/document/customs/dtpTypes";
import { formatNum4, formatNum, momentFormat } from "@/utils/utils";

//装箱单
export const Encasement: FC<RouterParamType> = (detailsInfo) => {
    const {
        editFormVal
    } = useDrodDetailModel(({ editFormVal }) => [editFormVal]);
    const { user: { shopCode } } = useGlobalModel(({ user }) => [user]);
    const { getTreeNodeName, getTreeNodeNameValue } = useDictModel(() => []);
    const [loading, setLoading] = useState<boolean>(false);  //导出pdf， 
    const [formVal, setFormVal] = useState<IDtpDetail | null>(null);
    const [list, setList] = useState<IDtpMaterialDetail[]>([])
    const [amountAll, setAmountAll] = useState<number>(0);
    const [currency, setCurrency] = useState<string>("")  //币种符号


    useEffect(() => {
        getDtpDetailOne()
    }, []);

    //获取一条数据
    const getDtpDetailOne = async () => {
        let { retData: { details, auditFlag, ...params } } = await enquiryService.one(editFormVal?.customsCode ?? "");

        //查询客户信息
        let { retData: { records: customerArr } } = await customerService.page({
            code: params.customerCode,
            pageNum: 1,
            pageSize: 15,
            shopCode,
        });
        setFormVal({
            ...params,
            address: customerArr[0]?.address,
            contact: customerArr[0]?.contact,
            email: customerArr[0]?.email,
            phone: customerArr[0]?.phone,
        })
        // //查询出运单的配件  毛重、净重信息
        let { retData: shipmentInfo } = await enquiryService.findBySaleCode(params.saleCode ?? "");
        let shipmentDetail = shipmentInfo?.details ?? [];
        let newList = (details ?? []).map(item => {
            let findShiment = shipmentDetail.find(shipmentItem => item.materialCode === shipmentItem.materialCode);
            return {
                ...item,
                netWeight: findShiment?.netWeight,
                grossWeight: findShiment?.grossWeight,
                // amount: formatNum(+(item.num ?? 0) * +(item.price ?? 0))
            }
        })
        setList(newList);
        setAmountAll(newList?.reduce((con, next) => { con += +(next.amount ?? 0); return con }, 0) ?? 0)
    }

    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            loading={loading}
            onClick={() => {
                setLoading(true);
                setTimeout(() => {
                    exportPDF("装箱单", "invoicePDF", () => {
                        setLoading(false);
                    })
                }, 1500);
            }}
        >导出PDF</Button>
    </>

    return (
        <YhBox title={action} style={{ marginBottom: "75px" }} >
            {formVal && <div style={{ width: "80%", margin: "10px auto" }} id="invoicePDF">
                {formVal.status === "clearance-status.effect" && <div className="seal-box"></div>}
                <h4 className="align-center">云湖春煜（天津）资产管理有限公司</h4>
                <h4 className="align-center">YUNHUCHUNYU(TIANJIN) ASSETS MANAGEMENT CO.,LTD</h4>
                <h4 className="align-center">装箱单  PACKING LIST </h4>
                {/* 单号 */}
                <p className="align-right">Invoice No.: {formVal.invoiceNumber}</p>
                {/* 日期 */}
                <p className="align-right">Date:{momentFormat(formVal.invoiceTime as string, "YYYY-MM-DD")}</p>
                {/* 发货人 */}
                <p>SHIPPER: {formVal.supplierName}</p>
                {/* 收货人 */}
                <p>CONSIGNEE: {formVal.customerName}</p>
                {/* 地址 */}
                <p>ADD:{formVal.address}</p>
                {/* 联系人 */}
                <p>CONTACT PERSON:{formVal.contact}</p>
                {/* 联系电话 */}
                <p>TEL:{formVal.phone}</p>
                {/* 邮箱 */}
                {/* <p className="mb-30">E-MAIL:{formVal.email}</p> */}
                <p>SHIPPING MARK：{formVal.labelNote}</p>
                <ul>
                    {/* 原产国 */}
                    {/* <li>COUNTRY OF ORIGN: {getTreeNodeName(formVal.countryTrade)}</li> */}
                    <li>COUNTRY OF ORIGN: CHINA</li>
                    {/* 供应国 */}
                    {/* <li>COUNTRY OF SUPPLY: {getTreeNodeName(formVal.destinationCountry)}</li> */}
                    <li>COUNTRY OF SUPPLY: CHINA</li>
                </ul>
                <ul>
                    {/* 发票编号 */}
                    <li>INVOICE NO: {formVal.invoiceNumber}</li>
                    {/* 发货港 */}
                    <li>PORT OF DISPATCH:{getTreeNodeName(formVal.portDeparture)}</li>
                </ul>
                <ul>
                    {/* 日期 */}
                    <li>Date: {momentFormat(formVal.invoiceTime as string, "YYYY-MM-DD")} </li>
                    {/* 卸货港口 */}
                    <li>PORT OF DESTINATION:{getTreeNodeName(formVal.dischargingPort)}</li>
                </ul>
                <table>
                    <tbody>
                        <tr>
                            <td>NO. <br />项目</td>
                            <td>NAME <br />商品名称</td>
                            <td>SPECIFICATIONS <br />规格型号</td>
                            <td>QTY <br />数量</td>
                            <td>UNIT <br />单位</td>
                            <td>NET WEIGHT(KG) <br />净重（千克）</td>
                            <td>GROSS WEIGHT(KG) <br />毛重（千克）</td>
                        </tr>
                        {
                            list && list.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <span>{item.materialName}</span>
                                        <br />
                                        <span>{item.materialEname}</span>
                                    </td>
                                    <td>{item.model}</td>
                                    <td>{item.num}</td>
                                    <td>{item.unitName}</td>
                                    <td>{formatNum(item.netWeight)}</td>
                                    <td>{formatNum(item.grossWeight)}</td>
                                </tr>
                            ))
                        }

                        <tr>
                            <td colSpan={5}>TOTAL</td>
                            <td colSpan={1}>{formatNum(formVal.suttle)}</td>
                            <td colSpan={1}>{formatNum(formVal.roughWeight)}</td>
                        </tr>
                    </tbody>
                </table>
                <p className="mt-20">TOTAL PACKAGE:{formVal.num}&nbsp;PKGS.</p>
                <p>TOTAL N.W.:{formatNum(formVal.suttle)}&nbsp;KGS</p>
                <p>TOTAL G.W.:{formatNum(formVal.roughWeight)}&nbsp;KGS</p>
                <p>TOTAL VOLUME:{formVal.volume}&nbsp;M3</p>
                <p className="align-right">YUNHUCHUNYU(TIANJIN) ASSETS MANAGEMENT CO.,LTD</p>
            </div>}
        </YhBox >
    )
}